module.exports = __webpack_public_path__ + "static/media/wizard-rolearn.4b30985e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wizard-rolearn.png
// module id = 800
// module chunks = 0